import React from 'react'

import { auth } from '../../firebase'

export const SignOutButton = () =>
    (
        <button type="button" onClick={auth.doSignOut}>
            Sign Out
        </button>
    )

export const SignOutLink = () =>
    (
        <div className="nav-link">
            Logout
        </div>
    )



// WEBPACK FOOTER //
// ./src/components/userManagement/SignOut.js